import { Sample } from './sample';



export interface Evaluation {
    key: string;
    sampleKey?: string;
    code: string;
    label: string;
    evalStartDate: any;
    evalEndDate: any;
    size: number;
    protocolId: string;

    sampleKeys?: string[];
    sampleCodes?: string[];
    massAction?: boolean;
    sample?: Sample;
    measures?: SampleMeasurement[];
    calculation?: SampleCalculation[];
    chars?: SampleCharacteristic[];
    notes?: SampleNote[];
    images?: SampleImage[];

    storageRegime: SampleStorage[];
    scheduleId: string;

    // Transient, request-only on create/update — resolved server-side into
    // color/overdueThresholdDays and never itself persisted or returned.
    sourceStorageRegimeKey?: string | null;

    // server-computed: due date + regime threshold vs now. null when this
    // Evaluation has no overdueThresholdDays snapshot (not generated by a Storage Regime).
    isOverdue?: boolean | null;

    // snapshot of the source regime's color, taken when this Evaluation was
    // generated. null when this Evaluation wasn't generated by a Storage Regime.
    color?: string | null;

    createdAt: string;
    updatedAt: string;
    deletedAt: string;
}

export interface SampleStorage {
    temp: number;
    duration: string;
    treatment?: string[];
    ca?: boolean;
    caOptions?: {
        co2?: number,
        o2?: number,
        eth?: number,
        rh?: number,
    };
}

export interface SampleCharacteristic {
    charId: string;
    value: string;
}

export interface SampleMeasurement {
    measureId: string;
    value: number;
    index: number;
    calculatedValue?: number;
    allValues?: number[];
    total?: number;
    sum?: number;
    createdAt?: string;
    updatedAt?: string;
}

export interface SampleCalculation {
    calcId: string;
    value: number;
    index: number;
}

export interface SampleNote {
    key: string;
    type: string;
    message: string;
    takenAt: string;
    deletedAt: string;
}

export interface SampleImage {
    key: string;
    name: string;
    evalKey: string;
    width: number;
    height: number;
    fileRef: string;
    note: string;
    takenAt: string;
    lat: number;
    lng: number;
    alt: number;
    deletedAt: string;
}

export interface CharacteristicImage {
    key: string;
    evalKey: string;
    charId: string;
    modelId: string;
    modelVersion: string;
    value: string;
    standardDeviation: number;
    name: string;
    width: number;
    height: number;
    fileRef: string;
    maskFileRef: string;
    annotatedFileRef: string;
    takenAt: string;
    createdAt: string;
    updatedAt: string;
    deletedAt: string;
}

export enum EvaluationStatus {
    /**
     * After start date and before end date
     */
    ONGOING = 'ONGOING',

    /**
     * Before start date
     */
    PENDING = 'PENDING',

    /**
     * After end date
     */
    COMPLETE = 'COMPLETE',

    /**
     * Invalid/missing dates
     */
    INVALID = 'INVALID',
}
